var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.linkList),function(item){return _c('xx-link',_vm._b({key:item.text,on:{"click":item.onClick}},'xx-link',_vm.omit(item, ['onClick']),false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }